import { WHITE, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getAccordionSectionStyles = () => {
  return StyleSheet.create({
    cardContainer: {
      borderWidth: 1,
      borderColor: WHITE
    },
    button: {
      alignSelf: 'flex-start',
      marginTop: tokens.spacing.SPACING_12
    }
  });
};